module.exports = __webpack_public_path__ + "static/fonts/Fact-ExpandedExtraLight.b336e89.eot";